export default __webpack_public_path__ + "static/media/Mark-5-HUD-Radar.8918a66e.jpg";